import { createAction } from 'redux-actions';
import {
    SEARCH_ADDRESS_REQUEST,
    SEARCH_ADDRESS_SUCCESS,
    SEARCH_ADDRESS_FAILURE,
    CLEAR_OPTIONS,
} from './geo-filter-constants';

export const searchAddressRequest = createAction(SEARCH_ADDRESS_REQUEST);
export const searchAddressSuccess = createAction(SEARCH_ADDRESS_SUCCESS);
export const searchAddressFailure = createAction(SEARCH_ADDRESS_FAILURE);

export const clearOptions = createAction(CLEAR_OPTIONS);
